import { ThemeColors } from '~/themes/colors'

export interface TooltipColors {
  Background: ThemeColors
  FontColor: ThemeColors
}

export const tooltipColors: TooltipColors = {
  Background: {
    default: 'black',
  },
  FontColor: {
    default: 'white',
  },
}
